export default "__VITE_ASSET__BlvSAZWk__"